import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import StickyChat from "./StickyChat";
import PageBreadcrumbs from "./PageBreadcrumbs";
import PageSeo from "./PageSeo";
import { DEFAULT_OG_IMAGE } from "@/lib/seo";

interface PageLayoutProps {
  children: ReactNode;
  title: string;
  description: string;
  ogImage?: string;
  breadcrumbLabel?: string;
}

const PageLayout = ({
  children,
  title,
  description,
  ogImage = DEFAULT_OG_IMAGE,
  breadcrumbLabel,
}: PageLayoutProps) => {
  const { pathname } = useLocation();

  return (
    <>
      <PageSeo
        title={title}
        description={description}
        ogImage={ogImage}
        breadcrumbLabel={breadcrumbLabel}
      />
      <Navbar />
      <main
        id="main-content"
        tabIndex={-1}
        className={`relative outline-none ${pathname === "/" ? "pt-16" : "pt-24 sm:pt-16"}`}
      >
        {pathname !== "/" && (
          <div className="pointer-events-none absolute left-0 right-0 top-[8.25rem] z-20 sm:top-[5.5rem]">
            <div className="container mx-auto px-4 lg:px-8">
              <PageBreadcrumbs
                currentLabel={breadcrumbLabel}
                className="pointer-events-auto"
              />
            </div>
          </div>
        )}
        {children}
      </main>
      <Footer />
      <StickyChat />
    </>
  );
};

export default PageLayout;
